"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPerformanceScpiFonction = void 0;
exports.ESubPerformanceScpiFonction = {
    dividendeDistribue: "dividendeDistribue",
    evolutionPrixPart: "evolutionPrixPart",
    desDeux: "desDeux",
};
